module.exports = __webpack_public_path__ + "static/img/null-list-icon_light.442df916.png";